module.exports = __webpack_public_path__ + "static/media/kit.a092985c.jpg";